import React, { useEffect, useState } from "react";

import JobCard from "components/job-card.component";

import { getLatestJobs, getLatestVacancies, safeApiCall } from "services/employer.service";
import { Job, MDRank, ReferenceData, Vacancy } from "services/types";
import VacancyCard from "components/vacancy-card.component";
import { getRanks, getJobTypes } from "services/config.service";
import { JOB_TYPES } from "services/constants";

function LatestJobPage() {

  const [latestJobs, setLatestJobs] = useState<Job[]>([]);
  const [latestVacancies, setLatestVacancies] = useState<Vacancy[]>([]);
  const [jobType, setJobType] = useState<string>("");
  const [jobTypeOthers, setJobTypeOthers] = useState<string>("");
  const [rank, setRank] = useState<string>("");
  const [jobTypes, setJobTypes] = useState<ReferenceData[]>([]);
  const [ranks, setRanks] = useState<MDRank[]>([]);

  useEffect(() => {
    (async () => {
      await safeApiCall(
        () => getJobTypes(),
        (res: any) => setJobTypes(res.data)
      )

      await safeApiCall(
        () => getLatestJobs(0),
        (res: any) => setLatestJobs(res.data.jobs)
      );

      await safeApiCall(
        () => getLatestVacancies(0),
        (res: any) => setLatestVacancies(res.data.vacancies)
      );
    })()
  }, []);


  const handleSearch = async () => {
    try {
      let jobTypeId = jobType;
      if (jobType === "OTH") {
        jobTypeId = jobTypeOthers
      }

      await safeApiCall(
        () => getLatestJobs(0, jobTypeId, rank),
        (res: any) => setLatestJobs(res.data.jobs)
      );

      await safeApiCall(
        () => getLatestVacancies(0, jobTypeId, rank),
        (res: any) => setLatestVacancies(res.data.vacancies)
      );
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <React.Fragment>
      <section className="jobs section">
        <div className="container" data-aos="fade-up">
          <hr/>
          <div className="row">
            <div className="col-md-4">
              <label className="form-label">Job Type</label>
              <div className="input-group mb-3">
                <select
                  name="job_type"
                  className="form-select"
                  value={jobType}
                  onChange={async (e: React.ChangeEvent<HTMLSelectElement>) => {
                    setJobType(e.target.value);

                    const selectedJobType = e.target.value;

                    // Reset rank
                    setRank("");

                    // Skip API call if empty or "OTH"
                    if (!selectedJobType || selectedJobType === "OTH" || selectedJobType === "ALL") {
                      setRanks([]);
                      return;
                    }

                    try {
                      const res = await getRanks(selectedJobType)
                      setRanks(res.data);
                    } catch (error: any) {
                      console.error(error.message);
                    }
                  }}
                >
                  <option value="">Select...</option>
                  {JOB_TYPES.map((r) => (
                    <option key={r.value} value={r.value}>
                      {r.label}
                    </option>
                  ))}
                  <option value="OTH">Others</option>
                </select>
                {jobType === 'OTH' && <select
                  name="job_type_others"
                  className="form-select"
                  value={jobTypeOthers}
                  onChange={async (e: React.ChangeEvent<HTMLSelectElement>) => {
                    setJobTypeOthers(e.target.value);

                    const selectedJobType = e.target.value;

                    // Reset rank
                    setRank("");

                    // Skip API call if empty or "OTH"
                    if (!selectedJobType) {
                      setRanks([]);
                      return;
                    }

                    try {
                      const res = await getRanks(selectedJobType)
                      setRanks(res.data);
                    } catch (error: any) {
                      console.error(error.message || "Something went wrong!");
                    }
                  }}
                >
                  <option value="">Select...</option>

                  {jobTypes.map((r) => (
                    <option key={r.id} value={r.id}>
                      {r.name}
                    </option>
                  ))}
                </select>}
              </div>
            </div>
            {jobType && jobType !== "ALL" && <div className="col-md-2">
              <label className="form-label">Rank</label>
              <select
                name="rank"
                className="form-select"
                value={rank}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setRank(e.target.value)}
              >
                <option value="">Select...</option>
                {ranks.map((r) => (
                  <option key={r.id} value={r.id}>
                    {r.name}
                  </option>
                ))}
              </select>
            </div>}
            <div className="col-md-2">
              <button
                type="button"
                className="btn btn-primary"
                style={{ marginTop: "1.95rem" }}
                onClick={handleSearch}
              >
                Search
              </button>
            </div>
          </div>
          <hr />
          <div className="section-header text-center mt-4 mb-4">
            <h2>Latest Job Openings</h2>
            <p>Explore opportunities that match your skills and experience</p>
          </div>

          <div className="row g-4 justify-content-center">
            {latestJobs.map((job) => <JobCard key={job.ref_id} job={job} />)}
            {latestVacancies.map((vacancy) => <VacancyCard key={vacancy.ref_id} vacancy={vacancy} />)}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

export default LatestJobPage;
